import React from 'react'
import { Form } from 'react-bootstrap'

interface TextAreaProps {
  Text: string
  className: string
}

const TextArea: React.FC<TextAreaProps> = (props) => {
  const { Text, className } = props

  return (
    <Form.Group>
      <p className={className}>{Text}</p>
    </Form.Group>
  )
}

export default TextArea
